module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_detalj_2023_2.59287a87.jpg";